import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromSpatialModellerStore from 'src/app/spatial-modeller-store';
import * as fromGazetteerStore from 'src/app/shared/atlas-gazetteer/store';

@Component({
    selector: 'atlas-spatial-modeller-reports',
    templateUrl: './spatial-modeller-reports.component.html',
    styleUrls: ['./spatial-modeller-reports.component.less'],
    standalone: false
})
export class SpatialModellerReportsComponent {
  areTestStatsAvailable$ = this.spatialModellerStore$.select(
    fromSpatialModellerStore.getAreTestStatsAvailable
  );

  isSelectedPointEmpty$ = this.gazetteerStore$.select(
    fromGazetteerStore.getIsSelectedPointEmpty
  );

  constructor(
    private spatialModellerStore$: Store<fromSpatialModellerStore.State>,
    private gazetteerStore$: Store<fromGazetteerStore.State>
  ) {}
}
